<template>
  <div id="app">
    <NavbarTop />
    <router-view/>
  </div>
</template>

<script>
import NavbarTop from "@/components/NavbarTop";
export default {
  name: 'app',
  components: {
    NavbarTop
  },
  methods: {
    async loadCampaign() {
      const campaign = await this.$repo.campaign.getCampaign();
      this.$store.commit('setCampaign', campaign);
    }
  },
  async mounted() {
    await this.loadCampaign();
  }
}
</script>

<style lang="scss">
#app {
  font-size: 18px;
}
</style>
